import { Spinner, SpinnerSize } from "@fluentui/react";

const LoadingBlocker = (props) => {
  return <div className="loading-blocker" style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
    <Spinner size={SpinnerSize.large} />
  </div>
}

export default LoadingBlocker;